import { GridColumnVisibilityModel } from '@mui/x-data-grid/hooks/features/columns';

import {
  TabColOrder,
  KdTabColumnVisibility,
  TabColumnVisibiity,
} from '../@types/State';

const offByDefault = {
  race: false,
  personality: false,
  combo: true,
  location: false,
  ruler: false,
  note: false,
  group: false,
  requests: true,
  id: false,
  nwpa: false,
  objectives: false,
};

export const overview = (): GridColumnVisibilityModel => {
  return {
    ...offByDefault,
    race: false,
    personality: false,
    combo: true,
    draftTarget: false,
    draftRate: false,
  };
};

export const war = (): GridColumnVisibilityModel => {
  return {
    ...offByDefault,
    honor: false,
    nwpa: false,
    goodSpells: false,
  };
};

export const defaultCol = (): GridColumnVisibilityModel => {
  return {
    ...offByDefault,
  };
};

export const ops: GridColumnVisibilityModel = {};

export const armies = (): GridColumnVisibilityModel => {
  return {
    id: false,
    pid: true,
    slot: true,
    name: true,
    secondsRemaining: true,
    land: true,
    ambush: true,
    generals: true,
    solds: true,
    elites: true,
    horses: true,
    oSpecs: true,
    somAge: true,
  };
};

const tabColumnVisibility = (): TabColumnVisibiity => {
  return {
    overview: overview(),
    war: war(),
    resources: defaultCol(),
    military: defaultCol(),
    ops: ops,
    survey: defaultCol(),
    science: defaultCol(),
    armies: armies(),
    all: {},
  };
};

export const kdTabColumnVisibility: KdTabColumnVisibility = {
  own: tabColumnVisibility(),
  enemy: tabColumnVisibility(),
};

export const TabColumnOrder: TabColOrder = {
  overview: [],
  war: [],
  resources: [],
  military: [],
  survey: [],
  science: [],
  all: [],
};
